var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _line, _line2, _line3, _line4, _line5, _line6, _g, _line7, _line8, _line9, _line0, _line1, _line10, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 103,
    r: 80,
    fill: "#00FFFF",
    opacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 97,
    r: 80,
    fill: "#FF00FF",
    opacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 62 Q60 100 72 118 Q86 136 100 138 Q115 136 128 118 Q140 100 137 62 Z",
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3,
    transform: "rotate(2 100 100)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67 64 Q63 102 75 120 Q89 138 103 140 Q118 138 131 120 Q143 102 140 64 Z",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    transform: "rotate(2 100 100)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 70 Q42 68 40 88 Q38 108 64 108",
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 72 Q45 70 43 90 Q41 110 67 110",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137 74 Q158 78 160 96 Q162 116 137 112",
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140 76 Q161 80 163 98 Q165 118 140 114",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 138,
    width: 13,
    height: 20,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 140,
    width: 13,
    height: 20,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 157,
    width: 62,
    height: 11,
    rx: 3,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 159,
    width: 62,
    height: 11,
    rx: 3,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 76,
    x2: 80,
    y2: 112,
    stroke: "#C0C0C0",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 93,
    y1: 68,
    x2: 91,
    y2: 118,
    stroke: "#DDDDDD",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 66,
    x2: 104,
    y2: 118,
    stroke: "#EEEEEE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 115,
    y1: 70,
    x2: 117,
    y2: 116,
    stroke: "#C0C0C0",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 70,
    x2: 94,
    y2: 120,
    stroke: "#00CCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.45
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 107,
    y1: 68,
    x2: 109,
    y2: 118,
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(10 100 44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 26 L104 40 L118 40 L107 48 L111 62 L100 54 L89 62 L93 48 L82 40 L96 40 Z",
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 28 L107 42 L121 42 L110 50 L114 64 L103 56 L92 64 L96 50 L85 42 L99 42 Z",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 26 L104 40 L118 40 L107 48 L111 62 L100 54 L89 62 L93 48 L82 40 L96 40 Z",
    fill: "#C0C0C0",
    opacity: 0.55
  }))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 52,
    x2: 46,
    y2: 52,
    stroke: "#C0C0C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.8
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 47,
    x2: 41,
    y2: 57,
    stroke: "#C0C0C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 154,
    y1: 42,
    x2: 164,
    y2: 42,
    stroke: "#DDDDDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.7
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 159,
    y1: 37,
    x2: 159,
    y2: 47,
    stroke: "#DDDDDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.7
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 140,
    x2: 170,
    y2: 140,
    stroke: "#00FFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 166,
    y1: 136,
    x2: 166,
    y2: 144,
    stroke: "#00FFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 193,
    fontFamily: "'Courier New', monospace",
    fontSize: 11,
    fill: "#C0C0C0",
    textAnchor: "middle",
    fontWeight: "bold",
    letterSpacing: 3
  }, "SILVER")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 195,
    fontFamily: "'Courier New', monospace",
    fontSize: 11,
    fill: "#00CCCC",
    textAnchor: "middle",
    fontWeight: "bold",
    letterSpacing: 3,
    opacity: 0.45
  }, "SILVER")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.546ad59ea28e934b64195a6cdaa03379.svg";
export { ForwardRef as ReactComponent };